import { Directive, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ListViewComponent } from '@y42/core/list-view';
import { IRowNode } from 'ag-grid-community';
import { filter, tap } from 'rxjs';
import { AssetSidebarService } from '../asset-sidebar';

@UntilDestroy()
@Directive({ selector: 'y42-list-view[y42HighlightActiveAsset]' })
export class FeatureListViewHighlightActiveAssetDirective implements OnInit {
  constructor(
    private readonly listViewComponent: ListViewComponent,
    private readonly assetSidebar: AssetSidebarService,
  ) {}

  private selectedNode?: IRowNode;

  ngOnInit() {
    this.highlightRowOfActiveAsset().subscribe();
  }

  private highlightRowOfActiveAsset() {
    return this.assetSidebar.asset$.pipe(
      filter(() => !!this.listViewComponent.gridApi),
      tap((asset) => {
        if (asset) {
          this.selectedNode = this.listViewComponent.gridApi.getRowNode(asset.$path);
          this.selectedNode?.setSelected(true);
        } else {
          this.selectedNode?.setSelected(false);
        }
      }),
      untilDestroyed(this),
    );
  }
}
